import { saveAs } from 'file-saver';
import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import ModalBase from '../../../components/Modals/ModalBase';
import useAuthorizeEntity from '../../../hooks/admin/useAuthorizeEntity';

const AdTable = ({ data = [], columns, font, refetch }) => {
  const [filterText, setFilterText] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { authorizeEntity, loading, error } = useAuthorizeEntity();
  const handleAuthorization = async (id, isAuthorized) => {
    const result = await authorizeEntity(id, font, isAuthorized);
    if (result) {
      refetch();
      setIsModalOpen(false);
    }
  };

  const filteredItems = data.filter(
    (item) =>
      (item.name &&
        item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.userName &&
        item.userName.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.email &&
        item.email.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.foundation &&
        item.foundation.toLowerCase().includes(filterText.toLowerCase()))
  );

  const handleRowClick = (row) => {
    setSelectedRow(row);
    setIsModalOpen(true);
  };

  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredItems);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');

    // Crear un archivo Excel y generar un Blob para descargarlo
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    const dataBlob = new Blob([excelBuffer], {
      type: 'application/octet-stream',
    });

    saveAs(dataBlob, `${font}.xlsx`);
  };

  return (
    <div>
      <h2>Información de {font}</h2>
      <div className='search-bar'>
        <input
          type='text'
          placeholder='Buscar...'
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
        <button
          onClick={downloadExcel}
          className='btn primary'>
          Descargar Excel
        </button>
      </div>
      <DataTable
        columns={columns}
        data={filteredItems}
        highlightOnHover
        pagination
        onRowClicked={handleRowClick}
      />
      <ModalBase
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}>
        {selectedRow && (
          <div className='aut-modal-container'>
            <h3>Detalles {font}</h3>
            {font === 'transacción' ? (
              Object.keys(selectedRow)
                .filter((key) => key !== '_id')
                .map((key) => (
                  <p key={key}>
                    <strong>
                      {key.charAt(0).toUpperCase() + key.slice(1)}:
                    </strong>
                    {selectedRow[key]}
                  </p>
                ))
            ) : (
              <>
                {selectedRow.name && (
                  <p>
                    <strong>Nombre:</strong> {selectedRow.name}
                  </p>
                )}
                {selectedRow.email && (
                  <p>
                    <strong>Email:</strong> {selectedRow.email}
                  </p>
                )}
              </>
            )}

            {font !== 'transacción' && (
              <>
                <a
                  href={`https://www.nibi.com.co/${
                    font === 'fundación' ? 'fundaciones/id' : 'programas'
                  }/${selectedRow.name.replace(/ /g, '_')}`}
                  target='_blank'
                  rel='noreferrer'>
                  perfil completo de {font}
                </a>
                <div className='controls'>
                  <button
                    className='btn primary'
                    onClick={() => handleAuthorization(selectedRow._id, true)}
                    disabled={loading}>
                    {loading ? 'Autorizando...' : 'Autorizar'}
                  </button>
                  <button
                    className='btn primary'
                    onClick={() => handleAuthorization(selectedRow._id, false)}
                    disabled={loading}>
                    {loading ? 'Autorizando...' : 'Rechazar'}
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </ModalBase>
    </div>
  );
};

export default AdTable;
